import { getFileFormat } from './doc-functions';

export class MockDataStore {

    static fileFormats = [
        {
            key: "image/jpeg",
            icon: "fa-file-image",
            description: "Image (JPEG)",
            extensions: [".jpg", ".jpeg"],
            primaryExtension: '.jpg'
        },
        {
            key: "image/png",
            icon: "fa-file-image",
            description: "Image (PNG)",
            extensions: [".png"],
            primaryExtension: '.png'
        },
        {
            key: "application/pdf",
            icon: "fa-file-pdf",
            description: "PDF Document",
            extensions: [".pdf"],
            primaryExtension: '.pdf'
        },
        {
            key: "folder",
            icon: "fa-folder",
            description: "Folder (Directory)"
        },
        {
            key: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            icon: "fa-file-word",
            description: "MS Word",
            extensions: [".docx"],
            primaryExtension: '.docx'
        },
        {
            key: "application/msword",
            icon: "fa-file-word",
            description: "MS Word",
            extensions: [".doc"],
            primaryExtension: '.doc'
        },
        {
            key: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            icon: "fa-file-excel",
            description: "MS Excel",
            extensions: [".xlsx"],
            primaryExtension: '.xlsx'
        },
        {
            key: "application/vnd.ms-excel",
            icon: "fa-file-excel",
            description: "MS Excel",
            extensions: [".xls"],
            primaryExtension: '.xls'
        }
    ];

    static docTypes = [
        {
            documentType: "Contract",
            description: "The contract between the letting agent/management company (you) and the owner/landlord (them).",
            allowableFormats: [
                getFileFormat("application/pdf", MockDataStore.fileFormats),
                getFileFormat("application/vnd.openxmlformats-officedocument.wordprocessingml.document", MockDataStore.fileFormats),
                getFileFormat("application/msword", MockDataStore.fileFormats)
            ],
            allowMultiple: false,
            applicationAreas: ['landlord'] // 'tenants', 'properties'
        },
        {
            documentType: "GSI",
            description: "Gas Safety Inspection Document",
            allowableFormats: [
                getFileFormat("application/pdf", MockDataStore.fileFormats),
                getFileFormat("application/vnd.openxmlformats-officedocument.wordprocessingml.document", MockDataStore.fileFormats),
                getFileFormat("application/msword", MockDataStore.fileFormats)
            ],
            allowMultiple: true,
            applicationAreas: ['landlord'] // 'tenants', 'properties'
        }
    ];
}